import { render, staticRenderFns } from "./Fkoff.vue?vue&type=template&id=04ebb6c0&scoped=true&"
import script from "./Fkoff.vue?vue&type=script&lang=js&"
export * from "./Fkoff.vue?vue&type=script&lang=js&"
import style0 from "./Fkoff.vue?vue&type=style&index=0&id=04ebb6c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ebb6c0",
  null
  
)

export default component.exports
import {QLayout,QPageContainer,QPage,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QPageContainer,QPage,QCard,QCardSection})
